import Component from "./Component.js"
import Utils from "./Utils.js"

export default class CurrentTime extends Component {

  constructor(props, context) {
    super(props, context)
    this.state.currentTime = this.player.currentTime
    this.state.duration = this.player.duration
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onmediachange(event) {
    this.setState({currentTime: 0})
  }

  ontimeupdate(event) {
    this.setState({currentTime: Math.round(event.detail)})
  }

  onseeking() {
    this.setState({currentTime: Math.round(this.player.currentTime)})
  }

  ondurationchange(event) {
    this.setState({duration: Math.round(event.detail)})
  }

  render() {
    return <span className="amp-current-time">{Utils.formatTimecode(this.state.currentTime, this.state.duration)}</span>
  }

}
